import { addLocaleData } from 'react-intl'
import { registerLocale as registerDatePickerLocale } from 'react-datepicker'
import pl from 'date-fns/locale/pl'
import en from 'date-fns/locale/en-US'
import es from 'date-fns/locale/es'
import de from 'date-fns/locale/de'
import it from 'date-fns/locale/it'
import { LanguageLocale } from './types/LanguageLocale'

import polishLocale from './locales/pl_PL'
import englishLocale from './locales/en_US'
import germanLocale from './locales/de_DE'
import italianLocale from './locales/it_IT'

export * from './types/LanguageLocale'

export interface Locales {
  pl: LanguageLocale,
  en: LanguageLocale
  de: LanguageLocale
  it: LanguageLocale
}

registerDatePickerLocale('pl', pl)
registerDatePickerLocale('pl-PL', pl)
registerDatePickerLocale('es', es)
registerDatePickerLocale('es-ES', es)
registerDatePickerLocale('en', en)
registerDatePickerLocale('en-US', en)
registerDatePickerLocale('de', de)
registerDatePickerLocale('de-DE', de)
registerDatePickerLocale('it', it)
registerDatePickerLocale('it-IT', it)

addLocaleData([
  ...polishLocale.data,
  ...englishLocale.data,
  ...germanLocale.data,
  ...italianLocale.data
])

const languages: Locales = {
  pl: polishLocale,
  en: englishLocale,
  de: germanLocale,
  it: italianLocale
}

export default languages
